module.exports = __webpack_public_path__ + "img/kekurangan_dokumen.d8b2d718.svg";